import { motion } from 'framer-motion';

import './services.css';

const Services = ({ pageRef }) => {

  const services = [{
    title: "Product & Technology",
    description: "We transform your vision into reality with comprehensive product development services. From initial concept and market research to technical architecture and MVP development, we guide you through every stage of the product lifecycle. Our expertise includes product strategy, roadmap planning, and selecting the optimal technology stack to ensure your product's success in the market."
  }, {
    title: "Mobile & Web Development",
    description: "Create exceptional digital experiences across all platforms with our mobile and web development expertise. We build responsive, high-performance applications using modern frameworks like React, Flutter, and Swift. Whether it's iOS, Android, or progressive web apps, we deliver intuitive interfaces and seamless user experiences that engage your audience and drive business growth."
  }, {
    title: "Backend Development",
    description: "Power your applications with robust, scalable backend solutions built on cutting-edge technologies. We design and implement secure APIs, microservices architectures, and cloud-native systems using Python, Go, and Node.js. Our backend solutions ensure high availability, optimal performance, and seamless integration with third-party services while maintaining the highest security standards."
  }, {
    title: "AI Development",
    description: "Harness the power of artificial intelligence to automate processes and unlock new insights from your data. We develop custom AI solutions including machine learning models, natural language processing, computer vision, and predictive analytics. From intelligent chatbots to advanced recommendation systems, we help you leverage AI to gain competitive advantages and drive innovation in your business."
  }];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15
      }
    }
  };

  const cardVariants = {
    hidden: { y: 50, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        duration: 0.6,
        ease: "easeOut"
      }
    }
  };

  return (
    <section ref={pageRef} className="services-section" id="services">
      <motion.div
        className="services-container"
        variants={containerVariants}
        initial="visible"
        whileInView="visible"
        viewport={{ once: true, amount: 0.1 }}
      >
        <motion.div className="services-header" variants={cardVariants} initial="visible">
          <h2 className="services-title">Our Services</h2>
          <p className="services-subtitle">
            Comprehensive solutions tailored to your business needs
          </p>
        </motion.div>

        <motion.div className="services-grid" variants={containerVariants} initial="visible">
          {services.map((service, index) => (
            <motion.div
              key={index}
              className="service-card"
              variants={cardVariants}
              initial="visible"
              whileHover={{
                y: -10,
                transition: { duration: 0.3 }
              }}
            >
              <h3 className="service-title">{service.title}</h3>
              <p className="service-description">{service.description}</p>
            </motion.div>
          ))}
        </motion.div>
      </motion.div>
    </section>
  )
}

export default Services;